import { Observable } from "rxjs";
import { DataBasicProfileResultModel } from "../../models/user/data-basic-profile-result.model";
import { DataBasicProfileModel } from "../../models/user/data-basic-profile.model";
import { UserRepository } from "../../repositories/user.repository";
import { UseCase } from "../../base/use-case";

export class UpdatePersonalInfoProfileUseCase implements UseCase<DataBasicProfileModel, DataBasicProfileResultModel> {
    constructor(private userRepository: UserRepository) { }
    execute(
        params: DataBasicProfileModel,
    ): Observable<DataBasicProfileResultModel> {
        return this.userRepository.updatePersonalInfoProfile(params);
    }
}
